<script>
export default {
    computed: {
        defaultMonth() {
            let current = this.moment()

            if (current.isBetween(this.dateStart, this.dateEnd, 'month')) {
                current.subtract(1, 'months')
                if (current.isSameOrBefore(this.dateStart, 'month')) {
                    return current
                } else if (current.isSameOrAfter(this.dateEnd, 'month')) {
                    return this.dateEnd
                }

                return current
            } else if (current.isSameOrBefore(this.dateStart, 'month')) {
                return this.dateStart
            }

            return this.dateEnd
        },
    },
    data: () => ({
        selectedMonth: null,
    }),
    created() {
        this.dateStart = this.moment(this.$laravel.training.date_start)
        this.dateEnd = this.moment(this.$laravel.training.date_end)
        this.selectedMonth = this.defaultMonth
    },
}
</script>
<template>
    <div>
        <div style="margin: 20px 0;" class="text-right">
            <a-month-picker format="MMM YYYY" :defaultValue="defaultMonth" v-model="selectedMonth" />
        </div>

        <a-card title="Business Result">
            <performance-business-score-card aspect="BRE" perspective="FIN" :period="selectedMonth.format('YYYYMM')" :showFilter="false" :excludes="['action']" />
        </a-card>

        <a-card title="Business Process" style="margin-top: 24px;">
            <performance-business-score-card aspect="BPR" perspective="BUI" :period="selectedMonth.format('YYYYMM')" :showFilter="false" :excludes="['action']" />
        </a-card>

        <a-card title="Soft Competency" style="margin-top: 24px;">
            <performance-competency-score-card />
        </a-card>
    </div>
</template>
